import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import Honeybadger from "@honeybadger-io/js";
import ErrorBoundary from "@honeybadger-io/react";

if (process.env.REACT_APP_ENV !== "local") {
  const honeybadgerConfig = {
    apiKey: process.env.REACT_APP_HONEYBADGER_KEY,
    environment: process.env.REACT_APP_ENV,
  };
  const honeybadger = Honeybadger.configure(honeybadgerConfig);

  ReactDOM.render(
    <ErrorBoundary honeybadger={honeybadger}>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </ErrorBoundary>,
    document.getElementById("root")
  );
} else {
  ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    document.getElementById("root")
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
